import * as React from 'react';
import { Avatar, Image } from '@cian/ui-kit';
import * as styles from './Logo.css';

const DEFAULT_SIZE = 64;

export interface ILogoProps {
  src: string | null;
  size?: number;
}

export const Logo: React.FC<ILogoProps> = ({ src, size = DEFAULT_SIZE }) => {
  return src ? (
    <div className={styles['image']} style={{ width: size, height: size }}>
      <Image objectFit="contain" src={src} />
    </div>
  ) : (
    <Avatar type="builder" size={size} />
  );
};
